import {
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_DRAFT_STEPS,
} from '../../../../../shared/constants'
const exportHeaders = [
  'Id',
  'Client name',
  'Campaign name',
  'Amount',
  'Submitted',
  'Launch date',
  'Cities',
  'Missions',
  'Missions per week',
  'Weeks',
  'Stage',
  'Stage reached date',
]

const CAMPAIGN_CARD_ACTIONS = {
  CAMPAIGN_BUILDER: 'CAMPAIGN_BUILDER',
  CAMPAIGN_BUILDER_EDIT: 'CAMPAIGN_BUILDER_EDIT',
  CAMPAIGN_DASHBOARD: 'CAMPAIGN_DASHBOARD',
  CAMPAIGN_SETTINGS: 'CAMPAIGN_SETTINGS',
  CLIENT_EMAIL: 'CLIENT_EMAIL',
  ARCHIVE_CAMPAIGN: 'ARCHIVE_CAMPAIGN',
  APPROVE_CAMPAIGN: 'APPROVE_CAMPAIGN',
  DECLINE_CAMPAIGN: 'DECLINE_CAMPAIGN',
  FLYERS_DESIGN: 'FLYERS_DESIGN',
  SEND_TO_DRAFT: 'SEND_TO_DRAFT',
  DIGITAL_PROOF_PAGE: 'DIGITAL_PROOF_PAGE',
  CODES_PAGE: 'CODES_PAGE',
  ACTIVATE_CAMPAIGN: 'ACTIVATE_CAMPAIGN',
}

const CAMPAIGN_BUILDER_CARD_OPTIONS = new Set([
  CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
  CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER_EDIT,
])

const campaignCardOptions = {
  [CAMPAIGN_INTERNAL_STATUSES.DRAFT]: [
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW]: [
    CAMPAIGN_CARD_ACTIONS.APPROVE_CAMPAIGN,
    CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    // CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.DECLINE_CAMPAIGN,
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES]: [
    CAMPAIGN_CARD_ACTIONS.CODES_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    // CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW]: [
    CAMPAIGN_CARD_ACTIONS.CODES_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    // CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF]: [
    CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    // CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF]: [
    CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    // CAMPAIGN_CARD_ACTIONS.SEND_TO_DRAFT,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ARCHIVE_CAMPAIGN,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.PAYMENT]: [
    CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.ACTIVATE_CAMPAIGN,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
  ],
  [CAMPAIGN_INTERNAL_STATUSES.ACTIVE]: [
    CAMPAIGN_CARD_ACTIONS.DIGITAL_PROOF_PAGE,
    'DIVIDER',
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_BUILDER,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_DASHBOARD,
    CAMPAIGN_CARD_ACTIONS.CAMPAIGN_SETTINGS,
    CAMPAIGN_CARD_ACTIONS.FLYERS_DESIGN,
    CAMPAIGN_CARD_ACTIONS.CLIENT_EMAIL,
  ],
}

/** draft titles are offset by one, showing the current step, instead of last completed */
const columnTitles = {
  [CAMPAIGN_DRAFT_STEPS.HOME]: 'AUDIENCE/SEGMENTS',
  [CAMPAIGN_DRAFT_STEPS.ENTRY]: 'DESIGN',
  [CAMPAIGN_DRAFT_STEPS.DESIGN]: 'DETAILS',
  [CAMPAIGN_DRAFT_STEPS.DETAILS]: 'SUBMIT',
  [CAMPAIGN_DRAFT_STEPS.REJECTED]: 'REJECTED',
  [CAMPAIGN_INTERNAL_STATUSES.DRAFT]: 'DRAFT',
  [CAMPAIGN_INTERNAL_STATUSES.IN_REVIEW]: 'IN REVIEW',
  [CAMPAIGN_INTERNAL_STATUSES.UPLOAD_CODES]: 'UPLOAD CODES',
  [CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW]: 'CODE REVIEW',
  [CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF]:
    'GENERATING DIGITAL PROOF',
  [CAMPAIGN_INTERNAL_STATUSES.PENDING_DIGITAL_PROOF]: 'PENDING DIGITAL PROOF',
  [CAMPAIGN_INTERNAL_STATUSES.PAYMENT]: 'PRINTING',
  [CAMPAIGN_INTERNAL_STATUSES.ACTIVE]: 'ACTIVE',
}

const EMAIL_TYPE = {
  DEFAULT: 'DEFAULT',
  APPROVE_CAMPAIGN: 'APPROVE_CAMPAIGN',
  DECLINE_CAMPAIGN: 'DECLINE_CAMPAIGN',
}

const DEFAULT_FILTER_OPTION = {
  label: 'ALL',
  value: null,
}

export {
  exportHeaders,
  campaignCardOptions,
  columnTitles,
  CAMPAIGN_CARD_ACTIONS,
  CAMPAIGN_BUILDER_CARD_OPTIONS,
  EMAIL_TYPE,
  DEFAULT_FILTER_OPTION,
}
